export enum BookingStatusEnum {
    PANIER_EN_COURS = "PANIER_EN_COURS",
    QUOTE = "QUOTE",
    RESERVATION = "RESERVATION",
    CANCELLED = "CANCELLED",
    UNAVAILABLE = "UNAVAILABLE",
    OVERBOOKING = "OVERBOOKING",
    ERROR = "ERROR",
    NONE = "NONE",
}